"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.Routes = {
    getAll: '/rollouts/',
    createOrUpdateUserRollout: '/rollouts/create_or_update_user_rollout/'
};
//# sourceMappingURL=Rollouts.consts.js.map